import styled from "styled-components";

interface InquiryFaqItemStyleProps {
  $active: boolean;
}

export const InquiryFaqItem = styled.li`
  display: flex;
  padding: 20px;
  box-shadow: ${(props) => props.theme.shadows.box};
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  flex-direction: column;
`;

export const ItemTit = styled.div<InquiryFaqItemStyleProps>`
  gap: 10px;
  display: flex;
  border-bottom: ${(props) =>
    props.$active ? "1px solid " + props.theme.colors.black5 : "none"};
  padding-bottom: ${(props) => (props.$active ? "20px" : 0)};
  justify-content: space-between;

  div {
    gap: 6px;
    color: ${(props) => props.theme.colors.text4};
    display: flex;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 20px;

    span {
      color: ${(props) => props.theme.colors.black60};
      font-size: 1.2rem;
      font-weight: 800;
      line-height: 20px;
    }
  }

  svg {
    transform: ${(props) =>
      props.$active ? "rotate(90deg)" : "rotate(270deg)"};
    transition: all 0.3s ease;

    path {
      fill: ${(props) =>
        props.$active
          ? props.theme.colors.primary100
          : props.theme.colors.black50};
    }
  }
`;

export const ItemAnswer = styled.div<InquiryFaqItemStyleProps>`
  gap: 6px;
  color: ${(props) => props.theme.colors.text4};
  display: flex;
  opacity: ${(props) => (props.$active ? 1 : 0)};
  overflow: hidden;
  font-size: 1.4rem;
  word-break: keep-all;
  transition: all 0.3s ease;
  max-height: ${(props) => (props.$active ? "100%" : 0)};
  margin-top: ${(props) => (props.$active ? "20px" : 0)};
  font-weight: 300;
  line-height: 20px;
  white-space: pre-line;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.2rem;
    font-weight: 800;
    line-height: 20px;
  }
`;
